// Review-cycle selection helpers.
//
// A Mid-Year review is a check-in against the priorities an employee set in
// their most recent *prior* Annual review. "Prior" means the newest Annual
// cycle whose year is strictly less than the Mid-Year cycle's year — so the
// Mid-Year 2026 form reflects on Annual 2025, never on an in-progress Annual
// 2026. Selecting by "newest Annual cycle" alone is wrong: the moment an
// Annual cycle for the current (or a future) year exists, it would shadow the
// completed prior-year review the mid-year is supposed to reference.

export function selectPriorAnnualCycle(annualCycles, midYearCycle) {
  if (!midYearCycle || typeof midYearCycle.year !== 'number') return null;
  if (!Array.isArray(annualCycles)) return null;
  // Single pass for the max-year prior Annual — no sort, preserves order on
  // ties (which shouldn't occur: at most one Annual cycle per year).
  let best = null;
  for (const c of annualCycles) {
    if (
      c &&
      c.type === 'Annual' &&
      typeof c.year === 'number' &&
      c.year < midYearCycle.year &&
      (best === null || c.year > best.year)
    ) {
      best = c;
    }
  }
  return best;
}
